<template>
  <ul class="top-pic clearfix">
    <li v-for="(item, index) in picList" :key="index">
      <img :src="item.pic_url" />
      <p>{{ item.txt }}</p>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    picList: Array
  }
}
</script>

<style lang="scss" scoped>
.top-pic {
  padding-left: 32px;
  li {
    width: 200px;
    float: left;
    text-align: center;
    margin-right: 16px;
    img {
      width: 90px;
      height: 90px;
      margin-bottom: 16px;
    }
    p {
      color: #000;
      font-size: 14px;
    }
  }
}
</style>

